import React, { useState } from "react";
import {
  AssetType,
  useDeleteAssetLocationsMutation,
  useGetAssetLocationsQuery,
} from "../store/slices/mapsSlice";
import MyPagination from "../Common/MyPagination";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function AssetLocationsList({
  selectedAsset,
}: {
  selectedAsset: Partial<AssetType>;
}) {
  const [pagination, setPagination] = useState({ page: 0, perPage: 12 });
  const { data: { locations, total } = { locations: [], total: 0 } } =
    useGetAssetLocationsQuery({
      uuid: selectedAsset?.Uuid ?? "",
      ...pagination,
    });
  const [deleteAssetLocation] = useDeleteAssetLocationsMutation();
  const confirmDialog = useConfirmDialog();
  const handleDeleteLocation = async (locationUuid: string) => {
    if (
      !(await confirmDialog(
        "Delete location",
        `Are you sure you want to delete this location?`
      ))
    ) {
      return;
    }
    if (!selectedAsset?.Uuid) return;
    const response: any = await deleteAssetLocation({
      assetUuid: selectedAsset?.Uuid,
      body: [locationUuid],
    });
    if (response.error) {
      console.log(response.error);
      return;
    }
    toast.success("Location deleted");
  };
  return (
    <div className="">
      <div className="flex-grow-1">
        <div>
          <span className="fw-bold">Asset name:</span>
          <span className="text-secondary ms-2">{selectedAsset.Label}</span>
        </div>
        <div>
          <span className="fw-bold">Asset description:</span>
          <span className="text-secondary ms-2">
            {selectedAsset.Description}
          </span>
        </div>
        <div className="text-secondary">Location lists of the assets</div>
      </div>
      <table className="table my-3">
        <thead>
          <tr>
            <th>Type</th>
            <th>Location</th>
            <th>Address</th>
            <th>Created at</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {locations?.map((l) => (
            <tr key={l.Uuid}>
              <td>
                {l.IsShape ? (
                  <div className="badge bg-secondary">POLYGON </div>
                ) : (
                  <div className="badge bg-secondary">POINT </div>
                )}
              </td>
              <td>
                {l.IsShape ? (
                  <div>
                    <div className="text-nowrap">
                      centre lat: {l.Point?.coordinates[1]}
                    </div>
                    <div className=" text-nowrap">
                      centre lng: {l.Point?.coordinates[0]}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className=" text-nowrap">
                      lat: {l.Point?.coordinates[1]}
                    </div>
                    <div className=" text-nowrap">
                      lng: {l.Point?.coordinates[0]}
                    </div>
                  </div>
                )}
              </td>
              <td>{l.Description || "N/A"}</td>
              <td>
                {l.CreatedAt ? new Date(l.CreatedAt).toLocaleString() : "N/A"}
              </td>
              <td>
                <Button
                  className=" bg-colored-reverse fw-bold border-none"
                  onClick={() => handleDeleteLocation(l.Uuid ?? "")}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!locations?.length && (
        <div className="alert alert-warning text-center">
          No locations found
        </div>
      )}
      <MyPagination
        total={total}
        onPaginate={(page: number, perPage: number) =>
          setPagination({ page, perPage })
        }
      />
    </div>
  );
}
